import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classNames from 'classnames';
import * as spinnerActions from '../actions/spinnerActions';

const SpinnerRedux = ({showSpinner, actions, showCloseButton = false}) =>
{
    return (
        <div id="content-preloader" className={classNames({'hidden-xs-up': !showSpinner})}>
            {showCloseButton
                ? <span id="close-preloader-button" className="clickable" onClick={actions.hideSpinner}><i className="mdi mdi-close-circle mdi-48px"></i></span>
                : null
            }
            <div id="status">
                <div className={classNames('spinner', {'hidden-xs-up': !showSpinner})}></div>
            </div>
        </div>
    );

};

function mapStateToProps(state, ownProps) {
    return {
        showSpinner: state.showSpinner,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                spinnerActions,
            ), dispatch
        )
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(SpinnerRedux);


// WEBPACK FOOTER //
// ./web/src/components/SpinnerRedux.jsx